<template>
  <div class="rate-panel">
    <van-dialog
      @cancel="cancel"
      @confirm="confirm"
      :value="showRate"
      title=""
      show-cancel-button
      confirmButtonColor="#4465f3"
    >
      <div class="rate-panel-container">
        <van-rate v-model="value" :size="35" color="#ffd21e" void-icon="star" void-color="#eee" />
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: this.$route.params.id,
      value: 0
    }
  },
  computed: {
    showRate() {
      return this.$store.state.activePlay.panel.showRate
    }
  },
  methods: {
    cancel() {
      this.$store.commit('controlPanel', {showRate: false})
    },
    confirm() {
      this.$store.dispatch('handleGrade', {
        eventId: this.id,
        grade: this.value
      })
    }
  }
}
</script>

<style scoped lang="scss">
.rate-panel-container {
  text-align: center;
  padding: 60px 0;
}
</style>
